<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="custom-popup" style="width: 400px;">
      <div class="popup-header" style="width: 400px;">
        <table>
          <thead>
            <th>
              <h3>
                <span class="moderat-meGreen-bold">Site Name:</span>
              </h3>
            </th>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>
                  <span class="moderat-meGreen-12">{{ popupData && popupData.title ? popupData.title : 'N/A' }}</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="line-312" style="width: 400px;">
        <svg style="width: 100%; height: 1px;">
            <use href="@/assets/svg/newSvgIcon.svg#line312"></use>
        </svg>
      </div>
      <div class="chargers" v-if="showCharger" v-loading="loading" style="width: 400px;">
        <table class="styled-table w-100">
          <thead >
            <th>
              <span class="moderat-white-bold-12">Emission intensity</span><br>
              <span class="moderat-white-bold-12">(tCO2-e/MWh)</span>
            </th>
            <th>
              <span class="moderat-white-bold-12">Abatement AC</span><br>
              <span class="moderat-white-bold-12">(tCO2-e/MWh)</span>
            </th>
            <th>
              <span class="moderat-white-bold-12">Abatement DC</span><br>
              <span class="moderat-white-bold-12">(tCO2-e/MWh)</span>
            </th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="moderat-meGreen-12">
                  {{ popupData.emission_intensity == null
                      ? 0
                      : popupData.emission_intensity.toLocaleString() }}
                </span>
              </td>
              <td>
                <span class="moderat-meGreen-12">
                  {{
                      popupData.abatement_ac == null
                        ? 0
                        : popupData.abatement_ac.toLocaleString()
                    }}
                </span>
              </td>
              <td>
                <span class="moderat-meGreen-12">
                  {{
                    popupData.abatement_dc == null
                      ? 0
                      : popupData.abatement_dc.toLocaleString()
                  }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="popup-footer">
        <el-button
          @click="handleClick"
          class="view-more"
          link
          style="cursor: pointer"
        >
          {{ showCharger ? "View less" : "View more" }}
        </el-button>
      </div> -->
    </div>
  </template>
  
  <script>

  export default {
    props: {
      popupData: Object,
    },
    data() {
      return {
        loading: false,
        showCharger: true,
      };
    },
    
    computed: {

    },
    
    methods: {
      // handleClick() {
      //   this.showCharger = !this.showCharger;
      // },
    },
  };
  </script>
  
  